import type { FaireProductEntity } from "../../entity_types/product";

export const p_akituqrfym: FaireProductEntity = {
  token: "p_akituqrfym",
  type: "product",
  name: "Rainbow Happy Birthday Candles | Cake Candle |",
  brandToken: "b_7973d1d7",
  brandName: "Talking Tables USA - Home, Birthday, Games & Seasonal Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/0cfea624ac477c4b1368b2803ccca14ab5d1f13acff125bd501da71a09c56c3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/880a04dab6574d2029d01ea7ad18094dc4748942169b098ebc6bd1e073754390.jpeg",
    "https://cdn.faire.com/fastly/d4d00a963c572584a61e1c7a4883403c6cccb7b0c90c9ed724f92689af882fad.jpeg",
    "https://cdn.faire.com/fastly/e3b651549b6f64f2bba25cb8436bf4cb1744baeba01e93d53d1ed05ec1e9307a.jpeg",
    "https://cdn.faire.com/fastly/81d04701962ff30f6b6f6d9e0eea19a5576400b38ce0b683de1965cd40995a1d.jpeg",
  ],
  priceDollars: 3.7,
  description:
    "These adorable birthday candles spell out 'Happy Birthday' with rainbow letters dipped in gold. Perfect for any birthday cake, no matter the age.\n\n\n Each pack contains 13 multicolor letter candles spelling ‘Happy Birthday’.\n\n\nWe have removed the glitter and plastic packaging from this product to be more eco-friendly. \n\n\n\nAbout Talking Tables\n Talking Tables is a family-run, values-driven brand founded over 25 years ago by Clare Harris, with a passion for bringing people together. \n\n Our in-house team designs fun, colorful and thoughtfully crafted products across homeware, birthday, games and seasonal décor, bringing joy to every gathering and helping customers create meaningful moments with ease. \n\n Now stocked in over 3,500 independent stores alongside leading global retailers, we combine creative design with trusted production across 10 countries. \n\n We are a certified B Corp, committed to doing business responsibly, with plastic-free products, sustainably sourced materials and over 65,000 trees planted.",
  tags: [],
  msrpDollars: 7.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:11.260Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
